class TypeFilter {
    constructor(options) {
        this.options = {};

        this.id = new Date().getUTCMilliseconds() + Math.random();
        this.wrapper = $('<div class="filter-wrapper"/>');
        this.button = $('<button type="button" class="filter type-filter"/>')
            .attr('tabindex', 0)
            .attr('aria-label', 'Fototype')
            .attr('aria-controls', 'type-filter-' + this.id)
            .attr('aria-owns', 'type-filter-' + this.id)
            .on('click', this.onButtonClick.bind(this))
            .appendTo(this.wrapper);

        this.popover = $('<div class="popover hidden"/>')
            .appendTo(this.wrapper);

        this.popoverContent = $('<div class="content"/>')
            .appendTo(this.popover);

        const types = [
            { value: 1, text: 'Standaardfoto\'s'},
            { value: 2, text: 'Luchtfoto\'s'},
            { value: 3, text: 'Panoramas'},
            { value: 4, text: 'Schilderijen'},
            { value: 5, text: 'Tekeningen'},
            { value: 6, text: 'Stafkaarten'}
        ];
        let columns = $('<div class="columns"/>').appendTo(this.popoverContent);
        for (let option of types) {
            let div = $('<div class="option"/>').appendTo(columns);
            $('<input type="checkbox"/>')
                .attr('value', option.value)
                .attr('checked', 'checked')
                .attr('id', 'type-filter-' + this.id + '-' + option.value)
                .on('change', this.onChange.bind(this))
                .appendTo(div);
            $('<label/>')
                .attr('for', 'type-filter-' + this.id + '-' + option.value)
                .text(option.text)
                .appendTo(div);
        }
        this.inputs = this.popoverContent.find('input');

        $('<hr/>').appendTo(this.popoverContent);
        let div = $('<div class="option wide"/>').appendTo(this.popoverContent);
        this.comparableInput = $('<input type="checkbox"/>')
            .attr('value', 1)
            .attr('id', 'type-filter-compare')
            .on('change', this.onChange.bind(this))
            .appendTo(div);
        $('<label/>')
            .attr('for', 'type-filter-compare')
            .text('Enkel vergelijkbaar met heden')
            .appendTo(div);

        this.options = $.extend(this.options, options);

        this.updateContent();
        this.updateVisibility();
    }
    appendTo(element) {
        this.wrapper.appendTo(element);
        return this;
    }
    insertAfter(element) {
        this.wrapper.insertAfter(element);
        return this;
    }
    updateContent() {
        let checked = [];
        let unchecked = [];
        for (let value of this.val()) {
            if (value.checked) checked.push(value.text);
            else unchecked.push(value.text);
        }
        this.isFiltered = (unchecked.length > 0 || this.comparableInput.prop('checked'));
        if (unchecked.length === 0 && this.comparableInput.prop('checked')) this.button.text('Vergelijkbaar met heden');
        else if (unchecked.length === 0) this.button.text('Elke soort foto');
        else if (unchecked.length === 1) this.button.text('Geen ' + unchecked[0].toLowerCase());
        else if (checked.length === 1) this.button.text('Enkel ' + checked[0].toLowerCase());
        else if (checked.length === 0) this.button.text('Geen enkele soort foto');
        else this.button.text(checked.length + ' soorten foto\'s');
    }
    updateVisibility() {
        this.button.attr('aria-expanded', this.isVisible ? 'true' : 'false');
        this.popover.attr('aria-hidden', this.isVisible ? 'false' : 'true');
    }
    toggle() {
        if (this.isVisible) this.hide();
        else this.show();
    }
    show() {
        this.wrapper.addClass('visible');
        if (this.hideTimer) clearTimeout(this.hideTimer);
        if (this.showTimer) clearTimeout(this.showTimer);

        if (!this.mouseDownHandler) this.mouseDownHandler = this.onMouseDown.bind(this);
        $(document).on('mousedown', this.mouseDownHandler);

        this.button.addClass('no-radius');
        this.popover.removeClass('hidden');
        this.updateVisibility();

        this.showTimer = setTimeout(function(){
            this.popover.css('max-height', this.popoverContent.height());
        }.bind(this), 10);
    }
    hide() {
        this.wrapper.removeClass('visible');
        if (this.hideTimer) clearTimeout(this.hideTimer);
        if (this.showTimer) clearTimeout(this.showTimer);

        if (this.mouseDownHandler) $(document).off('mousedown', this.mouseDownHandler);

        this.popover.css('max-height', false);
        this.updateVisibility();

        this.hideTimer = setTimeout(function(){
            this.button.removeClass('no-radius');
            this.popover.addClass('hidden');
        }.bind(this), 200);
    }
    reset() {
        this.inputs.prop('checked', true);
        this.comparableInput.prop('checked', false);
        this.updateContent();
        if (this.options.onChange) this.options.onChange(this);
    }
    onButtonClick(event) {
        if (event.which === 1) {
            this.toggle();
        }
    }
    onMouseDown(event) {
        if (event.which === 1 && this.isVisible) {
            if (!$.contains(this.wrapper[0], event.target)) this.hide();
        }
    }
    onChange() {
        this.updateContent();
        if (this.options.onChange) this.options.onChange(this);
    }
    val() {
        let val = [];
        this.inputs.each(function(){
            let input = $(this);
            val.push({
                value: input.attr('value'),
                text: input.next('label').text(),
                checked: input.prop('checked')
            })
        });
        return val;
    }
    onlyComparable() {
        return this.comparableInput.prop('checked');
    }
    get isVisible() {
        return this.wrapper.hasClass('visible');
    }
}
